import { render, staticRenderFns } from "./AddMetricModal.vue?vue&type=template&id=64f48406&scoped=true&lang=html"
import script from "./AddMetricModal.vue?vue&type=script&lang=js"
export * from "./AddMetricModal.vue?vue&type=script&lang=js"
import style0 from "./AddMetricModal.vue?vue&type=style&index=0&id=64f48406&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f48406",
  null
  
)

export default component.exports